// removed by extract-text-webpack-plugin
module.exports = {"container-background":"container-background","background-left":"background-left","background-right":"background-right"};


//////////////////
// WEBPACK FOOTER
// ./components/home/sub-view/_BackgroundPage.scss
// module id = ./components/home/sub-view/_BackgroundPage.scss
// module chunks = 0